<div class="ui padded grid">
  <div class="sixteen wide column">
    <div class="ui raised segment chatbot">
      <div class="ui grid">
        <ng-container [ngSwitch]="pageState">
          <ng-container *ngSwitchCase="pageStateEnum.LOADING">
            <div class="ui active dimmer">
              <div class="ui indeterminate text loader"></div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="pageStateEnum.LOADED">
            <div class="sixteen wide tablet four wide computer column">
              <monorepo-user-chat-list></monorepo-user-chat-list>
            </div>
            <div class="sixteen wide tablet twelve wide computer column">
              <monorepo-user-chat-detail></monorepo-user-chat-detail>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
